import { DocumentTextIcon } from "@heroicons/react/24/solid";
import { ConnectorIcon } from "../ConnectorIcon/ConnectorIcon";
import {
    FileSnapshot,
    DocumentType,
    SourceType,
} from "@/entities/DataAssociation/File.model";
import {
    QuestionMarkCircleIcon,
    ShareIcon,
    TagIcon,
} from "@heroicons/react/24/outline";

export function FileIcon({
    file,
    condensed = false,
}: {
    file: FileSnapshot;
    condensed?: boolean;
}) {
    if (file.meta?.rawConnector) {
        return (
            <ConnectorIcon
                connectorType={file.meta.rawConnector.kind}
                condensed={condensed}
            />
        );
    }

    if (file.sourceType === SourceType.UploadedFile) {
        return (
            <div className="flex items-center gap-1">
                <DocumentTextIcon
                    height={20}
                    width={18}
                    className=" fill-brand-300"
                />
                <p className="body-s capitalize">File</p>
            </div>
        );
    }

    if (file.documentType === DocumentType.LABELED) {
        return (
            <div className="flex items-center gap-1">
                <TagIcon className="stroke-default size-4" />
                <p className="body-s text-default">Labeled</p>
            </div>
        );
    }

    if (file.sourceType === SourceType.Connector) {
        return <ShareIcon width={16} />;
    }

    return (
        <div className="flex items-center gap-1">
            <QuestionMarkCircleIcon className="stroke-default size-4" />
            <p className="body-s text-default">Unknown</p>
        </div>
    );
}
